// Partial copy of `cs-core` enum `UiViewType`.
export const UI_VIEW_TYPE_AVATAR = `avatar`
export const UI_VIEW_TYPE_COVER = `cover`
export const UI_VIEW_TYPE_MULTI = `multi`
export const UI_VIEW_TYPE_TEXT = `text`

// Field types copied from `cs-core`.
export const UI_FIELD_TYPE_BOOK_FILE = `bookFile`
export const UI_FIELD_TYPE_BOOL = `bool`
export const UI_FIELD_TYPE_TER = `ter`
export const UI_FIELD_TYPE_CENTS = `cents`
export const UI_FIELD_TYPE_CHECKBOX = `checkbox`
export const UI_FIELD_TYPE_FILE = `file`
export const UI_FIELD_TYPE_GEO_NAME = `geoName`
export const UI_FIELD_TYPE_GEO_POINT = `geoPoint`
export const UI_FIELD_TYPE_GOOGLE_PLACE_NAME = `googlePlaceName`
export const UI_FIELD_TYPE_GOOGLE_PLACE_ID = `googlePlaceId`
export const UI_FIELD_TYPE_HIDDEN = `hidden`
export const UI_FIELD_TYPE_IMAGE_FILE = `imageFile`
export const UI_FIELD_TYPE_NUMBER = `number`
export const UI_FIELD_TYPE_RADIO = `radio`
export const UI_FIELD_TYPE_RATE_DEC = `rateDec`
export const UI_FIELD_TYPE_RATE_PENTA = `ratePenta`
export const UI_FIELD_TYPE_SEARCH = `search`
export const UI_FIELD_TYPE_SELECT = `select`
export const UI_FIELD_TYPE_TEXT = `text`
export const UI_FIELD_TYPE_TEXTAREA = `textarea`
export const UI_FIELD_TYPE_TEXTAREA_MD = `textareaMd`
export const UI_FIELD_TYPE_TEXT_MD = `textMd`

// Client-only field types.
export const UI_FIELD_TYPE_AVATAR_FILE = `avatarFile`
export const UI_FIELD_TYPE_VIDEO_FILE = `videoFile`
export const UI_FIELD_TYPE_INPUT_LADDER = `inputLadder`
export const UI_FIELD_TYPE_SELECT_LADDER = `selectLadder`
export const UI_FIELD_TYPE_TEXT_WITH_RADIO = `textWithRadio`
export const UI_FIELD_TYPE_NUMBER_WITH_RADIO = `numberWithRadio`
export const UI_FIELD_TYPE_CENTS_WITH_RADIO = `centsWithRadio`
export const UI_FIELD_TYPE_STAR_RATING = `starRating`
export const UI_FIELD_TYPE_DROPDOWN = `dropdown`
export const UI_FIELD_TYPE_PASSWORD = `password`
export const UI_FIELD_TYPE_SWITCH = `switch`
export const UI_FIELD_TYPE_DATE = `date`
export const UI_FIELD_TYPE_DATETIME = `datetime`
export const UI_FIELD_TYPE_EMAIL = `email`
export const UI_FIELD_TYPE_PHONE = `phone`